import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bannerdelete',
  templateUrl: './bannerdelete.component.html',
  styleUrls: ['./bannerdelete.component.scss']
})
export class BannerdeleteComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
